import * as React from "react"
import * as LabelPrimitive from "@radix-ui/react-label"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const labelVariants = cva(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
)

function withRedRequiredMark(children) {
  if (typeof children !== 'string') return children;
  const match = children.match(/^([\s\S]*?)\s+\*\s*$/);
  if (!match) return children;
  return (
    <>
      {match[1]}
      <span className="text-red-500"> *</span>
    </>
  );
}

const Label = React.forwardRef(({ className, children, ...props }, ref) => (
  <LabelPrimitive.Root ref={ref} className={cn(labelVariants(), className)} {...props}>
    {withRedRequiredMark(children)}
  </LabelPrimitive.Root>
))
Label.displayName = LabelPrimitive.Root.displayName

export { Label }
